import { FC } from "react";
import { Outlet } from "react-router-dom";
import {
  Box,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Sidebar, SidebarInner, SIDEBAR_WIDTH } from "@Components/Shell/Sidebar";
import { Topbar } from "@Components/Shell/Topbar";

export const AuthenticatedLayout: FC = () => {
  // Drawer overlay (mobile/tablet) — começa fechado.
  const drawer = useDisclosure();
  // Sidebar fixa (desktop) — começa expandida (o menu era fixo antes).
  const desktopSidebar = useDisclosure({ defaultIsOpen: true });

  // No desktop o hambúrguer recolhe/expande a sidebar; no mobile abre o drawer.
  const isDesktop = useBreakpointValue({ base: false, lg: true }) ?? false;

  const handleMenu = () => {
    if (isDesktop) {
      desktopSidebar.onToggle();
    } else {
      drawer.onOpen();
    }
  };

  // Offset do topo/conteúdo acompanha a largura real da sidebar no desktop.
  const desktopOffset = desktopSidebar.isOpen ? SIDEBAR_WIDTH : "0px";

  return (
    <Box minH="100vh" bg="neutrals.background.weak-50">
      {/* Sidebar fixa — só no desktop, recolhível */}
      <Box display={{ base: "none", lg: "block" }}>
        <Sidebar isOpen={desktopSidebar.isOpen} />
      </Box>

      {/* Menu em drawer — no mobile/tablet */}
      <Drawer isOpen={drawer.isOpen} placement="left" onClose={drawer.onClose}>
        <DrawerOverlay />
        <DrawerContent maxW={SIDEBAR_WIDTH} w={SIDEBAR_WIDTH}>
          <SidebarInner onNavigate={drawer.onClose} />
        </DrawerContent>
      </Drawer>

      <Topbar onMenu={handleMenu} isSidebarOpen={desktopSidebar.isOpen} />

      <Box
        ml={{ base: 0, lg: desktopOffset }}
        pt="57px"
        minH="100vh"
        transition="margin-left 0.2s ease"
      >
        <Box p={{ base: "16px", md: "24px" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
